import React, { useState, useEffect, useCallback } from "react";
import {
  MenuItem,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  Typography,
} from "@mui/material";
import "../../Pages/Masters/Roles and Permissions/Filters//Scrollbar.css";
import { get } from "../../utils/api";

const MultiSelect = ({
  title,
  options = [],
  label = "Select",
  onChange,
  url = null,
  errors,
  name,
  marginTop,
  value = [],
  placeholder = "Tap to select",
}) => {
  const [selectedOptions, setSelectedOptions] = useState(value);
  const [fetchedOptions, setFetchedOptions] = useState([]);
  const fetchOptions = useCallback(() => {
    if (url) {
      get(url)
        .then((res) => {
          const data = res.data?.data || [];
          const formattedOptions = data.map((item) => ({
            value: item._id,
            label: item.name || item.equipment,
          }));
          setFetchedOptions(formattedOptions);
        })
        .catch((err) => console.error("Error fetching options:", err));
    }
  }, [url]);

  useEffect(() => {
    fetchOptions();
  }, [url, fetchOptions]);

  useEffect(() => {
    setSelectedOptions(value);
  }, [value]);

  const handleLocalChange = (event) => {
    const selectedValues = event.target.value;
    const currentOptions = url ? fetchedOptions : options;

    if (selectedValues.includes("all")) {
      const allSelected = selectedOptions.length !== currentOptions.length;
      const newSelected = allSelected
        ? currentOptions.map((opt) => opt.value)
        : [];
      setSelectedOptions(newSelected);
      onChange({ name, value: newSelected });
    } else {
      setSelectedOptions(selectedValues);
      onChange({ name, value: selectedValues });
    }
  };

  const availableOptions = url ? fetchedOptions : options;
  const isAllSelected = selectedOptions.length === availableOptions.length;

  return (
    <FormControl fullWidth>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "bold",
          mt: name === "consumptionPeriod" ? marginTop || 0 : 1,
        }}
      >
        {title}
      </Typography>
      <Select
        multiple
        size="small"
        value={selectedOptions}
        onChange={handleLocalChange}
        error={!!errors}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <em>{placeholder}</em>;
          }
          return availableOptions
            ?.filter((option) => selected.includes(option.value))
            .map((option) => option.label)
            .join(", ");
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 400,
              width: "10%",
              overflowY: "auto",
              padding: 0,
              margin: 0,
            },
          },
        }}
      >
        <MenuItem value="all" sx={{ padding: 0 }}>
          <Checkbox checked={isAllSelected} />
          <ListItemText primary="Select All" />
        </MenuItem>
        {availableOptions?.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ padding: 0 }}>
            <Checkbox checked={selectedOptions.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </FormControl>
  );
};

export default MultiSelect;
